<template>
  <team></team>
</template>
<script>
import Team from "../components/TeamManagement";
export default {
  components: {
    Team,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/MyTeam.vue